import {
  FETCH_MODULE,
} from '../actions/moduleAction';

const initialState = {};
const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MODULE: {
      const { moduleKey, subType, payload } = action;

      if (subType) {
        return {
          ...state,
          [moduleKey]: {
            ...state[moduleKey],
            [subType]: payload,
          },
        };
      }

      return {
        ...state,
        [moduleKey]: payload,
      };
    }
    default:
      return state;
  }
};
export default moduleReducer;
